import { useQuery } from "react-query";
import axios from "axios";
import { genericError } from "./errors";
import { useState } from "react";

export const useApiGet = (path: string, sub?: string) => {
  let unavailable;
  let data;

  const q = useQuery(path, () => axios.get(path).then((res) => res.data), {
    enabled: true,
    keepPreviousData: true,
  });

  if (q.isFetching && !q.isFetched) {
    unavailable = <div></div>;
  } else if (q.error) {
    unavailable = <div>There was an error</div>;
    genericError();
  } else if (q.isSuccess) {
    data = q.data;
  }

  return {
    [sub ? sub : "data"]: sub ? data?.[sub] : data,
    unavailable,
    refetch: q.refetch,
  };
};

export const usePageData = (root?: string) => {
  return useApiGet(location.pathname + location.search, root);
};

export const apiGet = (path, params = {}) => {
  const promise = axios.get(path, params);
  promise.catch(genericError);
  return promise;
};

export const useApiMutation = () => {
  let successCallback;
  let errorCallback;

  const [saving, setSaving] = useState(false);

  const makeRequest =
    (method: "put" | "post" | "delete") =>
    (path: string, data = {}, config = {}) => {
      setSaving(true);
      const promise = axios[method](path, data, config);
      promise.catch(genericError);
      promise.finally(() => setSaving(false));
      promise.then(({ data }) => {
        if (data.success) {
          successCallback?.(data as any);
        } else {
          errorCallback?.(data as any);
        }
      });
      const handler = {
        success: (fn) => {
          successCallback = fn;
          return handler;
        },
        error: (fn) => {
          errorCallback = fn;
          return handler;
        },
      };
      return handler;
    };

  const put = makeRequest("put");
  const post = makeRequest("post");
  const destroy = makeRequest("delete");

  return { post, put, destroy, saving };
};
